<div
  [class]="'ui-field-display ' + (width || '')"
  [class.is-clickable]="clickable"
  *ngIf="(!hideIf && value) || dontHide"
>
  <p class="ui-field-display__label">{{ label }}</p>
  <p class="ui-field-display__value">{{ value }}</p>
  <ng-content></ng-content>
</div>
